export default "__VITE_ASSET__BgF__naz__"